import { TakePicture } from '~/components';
import { MaskType } from '~/utils';

interface Props {
  handleSubmit: (image: string) => Promise<void>;
}

const OnboardingDocPhotoFront = ({ handleSubmit }: Props) => {
  return (
    <TakePicture
      handleSubmit={handleSubmit}
      allowFrontCamera={false}
      sceneTitle="Frente do documento"
      maskType={MaskType.DOCUMENT}
    />
  );
};

export default OnboardingDocPhotoFront;
